import { useContext } from 'react';
import { StoreContext } from '@roc/feature-app-core';
import { CreditReportStore } from '../stores/creditReportStore';

export const useCreditReportStore = () =>
  useContext<{
    creditReportStore: CreditReportStore;
  }>(StoreContext);